import { Logger } from '@frontend/logger';
import { useActiveModal, useModals } from '@frontend/modal';
import { SlotExtendedClient } from '@frontend/slot/api';
import { SlotExtended } from '@frontend/slot/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SlotsGridProps } from './slots-grid.component';

interface ViewProps {
    slots: SlotExtended[];
    isLoading: boolean;
    viewDetailedSlots: (module_id: string) => Promise<void>;
}

export const useSlotsGrid = (props: SlotsGridProps): ViewProps => {
    const [slots, setSlots] = useState<SlotExtended[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { modalId } = useActiveModal();
    const { closeModal } = useModals();

    useEffect(() => {
        if (!props.moduleId) return;

        setIsLoading(true);
        SlotExtendedClient.fetchSlotExtendeds({ module_id: props.moduleId, size: '10' })
            .then((response) => {
                setSlots(response.results);
            })
            .catch((error) => {
                Logger.error('Failed to fetch slots:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [props.moduleId]);

    async function viewDetailedSlots(module_id: string) {
        await navigate(`/spots/slots?module_id=${module_id}`);
        closeModal(modalId);
    }

    return {
        slots,
        isLoading,
        viewDetailedSlots
    };
};
